module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "track-card-simple"
  }, [_c('div', {
    staticClass: "cover",
    class: {
      noCover: _vm.noCover,
      round: _vm.round,
      coverRadius: _vm.coverRadius
    },
    style: (("background-image: url(" + _vm.cover + "); height: " + _vm.height + "px; width: " + (_vm.isVideo ? _vm.videoWidth : _vm.width) + "px"))
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "_title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-870d5704","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/trackcardsimple.vue
// module id = 1807
// module chunks = 180